<template>
    <div class="wrap">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist'>
                    <div class="blk1">
                        <img src="./image/banner1@2x.png" style="position:absolute;top:0;left:0;width: 100%;height: 100%"></img>
                        <div class="blkps">
                            <div class="blkrect"></div>
                            <div class="txtku1">故障报修</div>
                            <div class="txtku2">硬件报修</div>
                        </div>
                    </div>
                    <div class="notice">
                        <div><img src="./image/search@2x.png" class="img1"></img></div>
                        <div class="txt1">
                            <van-field class="field1" v-model="dInfo" placeholder="请输入设备相关信息" />
                        </div>
                        <div>
                            <div class="search" @click="search">搜索</div>
                        </div>
                    </div>
                    <div v-if="m_item.length>0">
                        <div class="engSty" v-for="(item,index) in m_item" :key="index" @click="tDetail(item)">
                            <!-- <div class="tSty">{{item.assetsId}}-{{item.assetsUserName}}-{{item.assetsName}}</div> -->
                            <div class="tSty">{{item.hardwareName}}</div>
                            <div class="subtSty">{{item.hardwareCode}}</div>

                        </div>
                    </div>
                    <div v-else class="nData">暂无数据</div>

                </div>

            </div>
        </div>
    </div>

</template>
<script>
import PJXQ from "@/components/pjxq.vue";
export default {
    components: { PJXQ },
    data() {
        return {
            dInfo: "",
            m_item: [],
            count: 0,
        };
    },
    methods: {
        tDetail(item) {
            this.$router.push({
                path: "/ypropertyDetail",
                query: {
                    code: item.hardwareCode,
                    tit: item.hardwareName,
                    id: item.hardwareId,
                    dictId: this.$route.query.dictId,
                    responseType: 1,
                },
            });
        },
        getData() {
            var wocao = [];
            wocao.push(this.$route.query.dictId);
            if (this.$store.state.user.userInfo.role == 1) {
                let data = {
                    assetsTypeId: wocao,
                    assetsCompanyId: this.$store.state.user.userInfo.companyId,
                };
                this.$api
                    .post("/app/corporateassets/getHardwareAssetsList", data)
                    .then((res) => {
                        if (res.data.code == "0000") {
                            this.m_item = res.data.data.datalist;
                        }
                    });
            } else if (this.$store.state.user.userInfo.role == 0) {
                let data = {
                    assetsTypeId: wocao,
                    assetsCompanyId: this.$store.state.user.userInfo.companyId,
                    assetsUserId: this.$store.state.user.userInfo.userId,
                };
                this.$api
                    .post("/app/corporateassets/getHardwareAssetsList", data)
                    .then((res) => {
                        if (res.data.code == "0000") {
                            this.m_item = res.data.data.datalist;
                        }
                    });
            }
        },
        getSearchData(dt) {
            var wocao = [];
            wocao.push(this.$route.query.dictId);
            if (this.$store.state.user.userInfo.role == 1) {
                let data = {
                    assetsTypeId: wocao,
                    assetsCompanyId: this.$store.state.user.userInfo.companyId,
                    assetsName: dt,
                };
                this.$api
                    .post("/app/corporateassets/getHardwareAssetsList", data)
                    .then((res) => {
                        if (res.data.code == "0000") {
                            this.m_item = res.data.data.datalist;
                        }
                    });
            } else if (this.$store.state.user.userInfo.role == 0) {
                let data = {
                    assetsTypeId: wocao,
                    assetsCompanyId: this.$store.state.user.userInfo.companyId,
                    assetsUserId: this.$store.state.user.userInfo.userId,
                    assetsName: dt,
                };
                this.$api
                    .post("/app/corporateassets/getHardwareAssetsList", data)
                    .then((res) => {
                        if (res.data.code == "0000") {
                            this.m_item = res.data.data.datalist;
                        }
                    });
            }
        },
        search() {
            this.getSearchData(this.dInfo);
        },
    },
    created() {
        this.getData();
    },
    mounted() {
        this.getData();
    },
};
</script>
<style scoped>
.wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    overflow: auto;
    background: #e9eef2;
    overflow-x: hidden;
}
.wrap_inner {
    min-height: 100%;
    width: 100%;
}
.wrap_main {
    padding-bottom: 20px;
}
.mainlist {
    width: 100%;
    height: 340px;
}
.img1 {
    width: 25px;
    height: 25px;
}
.blk1 {
    position: relative;
    width: 100%;
    height: 148px;
}
.txt1 {
    font-size: 16px;
    margin-left: 16px;
    color: #333;
}
.nData {
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
}
.field1 {
    width: 100%;
    height: 35px;
    line-height: 35px;
    padding: 0;
}
.engSty {
    width: 309px;
    height: 40px;
    padding: 18px 12px;
    margin: 20px auto;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    font-size: 12px;
}
.notice {
    display: flex;
    width: 90%px;
    height: 35px;
    padding: 0 5%;
    margin: 0px auto;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    font-size: 12px;
    align-items: center;
    justify-content: center;
}
.notice > div {
    flex: 1;
}
.notice > div:nth-child(1) {
    flex: 0 0 19px;
}
.notice > div:nth-child(3) {
    flex: 0 0 22px;
}
.tSty {
    overflow: hidden;
    　　text-overflow: ellipsis;
    　　white-space: nowrap;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
}
.subtSty {
    overflow: hidden;
    　　text-overflow: ellipsis;
    　　white-space: nowrap;
    margin-top: 3px;
    font-size: 9px;
    font-weight: 400;
    color: #333333;
}
.search {
    width: 57px;
    height: 23px;
    background: linear-gradient(116deg, #36b3fe 11%, #0080ff 91%);
    border-radius: 12px;
    font-size: 14px;
    color: #fff;
    text-align: center;
    line-height: 23px;
}
.blkps {
    position: absolute;
    top: 35px;
    right: 0px;
    width: 142px;
    height: 90px;
}
.blkrect {
    width: 20px;
    height: 2px;
    background: #ffffff;
}
.txtku1 {
    margin: 4px 0 10px 0;
    font-size: 20px;
    font-weight: 800;
    text-align: left;
    color: #ffffff;
}
.txtku2 {
    font-size: 16px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
}
</style>
